import {
  NarrativeUpdatePanel,
  type NarrativeUpdate,
} from '../NarrativeUpdatePanel';

type Props = {
  updates: NarrativeUpdate[];
};

export const NarrativeUpdates = ({ updates }: Props) => {
  return (
    <div className="grid gap-x2">
      {updates.map((update) => (
        <NarrativeUpdatePanel
          key={update.id}
          update={update}
          title="Shared on"
        />
      ))}
    </div>
  );
};
